import useInitializeMap from './useInitializeMap'

export default useInitializeMap
